import api from './api.service'

export const announcementService = {
    list,
    get,
    save,
    update,
    _delete,
    dismiss,
    markAsRead,
    getAnnouncements,
    getUsers,
    getDevices,
    getAnnouncementsForDevice
};

const BASE_URL = '/announcements'

function list(max) {
    return api.get(BASE_URL, {max : max || 1000})
}

function get(id) {
    return api.get(BASE_URL + '/' + id)
}

function save(announcement) {
    return api.post(BASE_URL, announcement)
}

function update(id, announcement) {
    return api.put(BASE_URL + "/" + id, announcement)
}

function _delete(id) {
    return api.delete(BASE_URL + "/" + id)
}

function dismiss(id) {
	return api.get('/announcement/dismiss/' + id)
}

function markAsRead(id) {
	return api.get('/announcement/markAsRead/' + id)
}

function getAnnouncements(max) {
    return api.get('/announcement/getAnnouncements/', {max : max || 1000})
}

function getUsers(max) {
    return api.get('/announcement/getUsers/', {max : max || 1000})
}

function getDevices(max) {
    return api.get('/announcement/getDevices/', {max : max || 1000})
}

function getAnnouncementsForDevice(deviceId) {
    return api.get('/announcement/getAnnouncementsForDevice/' + deviceId, {max : 1000})
}